"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const Stringify_1 = require("./Stringify");
exports.TextLinks = ({ value, colIndex, rowIndex, className, col, }) => {
    const id = `super-table-cell-row-${rowIndex}-col-${colIndex}-text`;
    const tooltip = value.tooltip || value.text;
    return (react_1.default.createElement("div", { className: `${className} p-2 d-flex justify-content-between align-items-center` },
        react_1.default.createElement("span", { id: id, className: "text-truncate" },
            react_1.default.createElement(Stringify_1.Stringify, { col: col, value: value.text }),
            tooltip && (react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { target: id },
                react_1.default.createElement(Stringify_1.Stringify, { col: col, value: tooltip })))),
        react_1.default.createElement("span", null, value.links &&
            value.links
                .filter((l) => Boolean(l.url))
                .map((link, index) => {
                const generatedId = `super-table-cell-row-${rowIndex}-col-${colIndex}-link-${index}`;
                return (react_1.default.createElement(react_1.default.Fragment, { key: JSON.stringify(link) + index },
                    react_1.default.createElement("a", { href: link.url, key: generatedId, target: "_blank", rel: "noopener noreferrer", className: "ml-1", id: generatedId },
                        react_1.default.createElement("i", { className: `fa ${link.icon}` })),
                    link.tooltip && (react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { target: generatedId },
                        react_1.default.createElement(Stringify_1.Stringify, { col: col, value: link.tooltip })))));
            }))));
};
//# sourceMappingURL=TextLinks.js.map